export enum SettingsTabs {
    Profile = 'profile',
    Security = 'security',
    Notifications = 'notifications',
}

export enum DashboardTabs {
    Security = 'security',
    System = 'system',
    Usage = 'usage',
}

export enum IntegrationsTabs {
    All = 'all',
    SoarSiem = 'soar-siem',
    BrowserExtension = 'browser-extension',
    StorageSecurity = 'storage-security',
    Collaboration = 'collaboration',
    WebIsolation = 'web-isolation',
    NetworkSecurity = 'network-security',
    CrmPlatforms = 'crm-platforms',
}
